module.exports = __webpack_public_path__ + "img/submit-bg-disable.73baf1a.png";